import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RoleGuard from 'utils/route-guard/RoleGuard';

const Channel = Loadable(lazy(() => import('views/Channel')));
const ChannelPricing = Loadable(lazy(() => import('views/ChannelPricing')));
const ChannelStats = Loadable(lazy(() => import('views/ChannelStats')));
const AvailableModels = Loadable(lazy(() => import('views/AvailableModels')));
const Log = Loadable(lazy(() => import('views/Log')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const Bill = Loadable(lazy(() => import('views/Bill')));
const BillManage = Loadable(lazy(() => import('views/BillManage')));
const User = Loadable(lazy(() => import('views/User')));
const UserPricing = Loadable(lazy(() => import('views/UserPricing')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const Chat = Loadable(lazy(() => import('views/Chat')));
const ModelSquare = Loadable(lazy(() => import('views/ModelSquare')));
const VideoGeneration = Loadable(lazy(() => import('views/VideoGeneration')));
const ApiDoc = Loadable(lazy(() => import('views/ApiDoc')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const UsageStats = Loadable(lazy(() => import('views/UsageStats')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Chat />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'usage_stats',
      element: <UsageStats />
    },
    {
      path: 'channel',
      element: (
        <RoleGuard minRole={10}>
          <Channel />
        </RoleGuard>
      )
    },
    {
      path: 'channel/pricing',
      element: (
        <RoleGuard minRole={10}>
          <ChannelPricing />
        </RoleGuard>
      )
    },
    {
      path: 'channel/stats',
      element: (
        <RoleGuard minRole={10}>
          <ChannelStats />
        </RoleGuard>
      )
    },
    {
      path: 'channel/available_models',
      element: (
        <RoleGuard minRole={10}>
          <AvailableModels />
        </RoleGuard>
      )
    },
    {
      path: 'chat',
      element: <Chat />
    },
    {
      path: 'video',
      element: <VideoGeneration />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'log/manage',
      element: (
        <RoleGuard minRole={10}>
          <Log scope="all" />
        </RoleGuard>
      )
    },
    {
      path: 'redemption',
      element: (
        <RoleGuard minRole={10}>
          <Redemption />
        </RoleGuard>
      )
    },
    {
      path: 'setting',
      element: (
        <RoleGuard minRole={100}>
          <Setting />
        </RoleGuard>
      )
    },
    {
      path: 'api_doc',
      element: <ApiDoc />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'model_square',
      element: <ModelSquare />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'bill',
      element: <Bill />
    },
    {
      path: 'bill/manage',
      element: (
        <RoleGuard minRole={10}>
          <BillManage />
        </RoleGuard>
      )
    },
    {
      path: 'user',
      element: (
        <RoleGuard minRole={10}>
          <User />
        </RoleGuard>
      )
    },
    {
      path: 'user/pricing',
      element: (
        <RoleGuard minRole={10}>
          <UserPricing />
        </RoleGuard>
      )
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
